// extracted by mini-css-extract-plugin
export default {"comment_box":"index_comment_box_vWT4L","username":"index_username_16g8a","content_txt":"index_content_txt_YaEn7"};